import { useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [
  ["name", "Property name"], ["tagline", "Tagline"], ["subtitle", "Subtitle"],
  ["phone", "Contact phone"], ["whatsapp", "WhatsApp number"],
  ["guest_portal_contact", "Guest Portal contact number (checked-in guests only, e.g. +91XXXXXXXXXX — falls back to WhatsApp number when empty)"],
  ["address", "Address"], ["city", "City"], ["state", "State"], ["pincode", "Pincode"],
  ["check_in_time", "Check-in time"], ["check_out_time", "Check-out time"],
  ["wifi_name", "Wi-Fi name"], ["wifi_password", "Wi-Fi password"],
];
const AREAS = [
  ["description", "Property description"], ["arrival_instructions", "Arrival instructions"],
  ["house_rules", "House rules"], ["pet_policy", "Pet policy"], ["cancellation_policy", "Cancellation policy"],
];

export default function PropertyInfoSettings({ prop }) {
  const [f, setF] = useState(() => {
    const init = {};
    [...FIELDS, ...AREAS].forEach(([k]) => { init[k] = prop?.[k] || ""; });
    return init;
  });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      await http.put("/admin/property", f);
      toast.success("Property information saved");
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card md:col-span-2" data-testid="property-info-settings">
      <h3 className="font-serif text-2xl mb-1">Property Information</h3>
      <p className="text-xs mb-4" style={{ color: "var(--muted)" }}>
        Shown on the public website and guest portal. Editing here updates the site — no code change needed.
      </p>
      <div className="grid md:grid-cols-3 gap-3">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>{label}</label>
            <input data-testid={`prop-${k}`} value={f[k]} onChange={(e) => set(k, e.target.value)} />
          </div>
        ))}
      </div>
      <div className="grid gap-3 mt-3">
        {AREAS.map(([k, label]) => (
          <div key={k}>
            <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>{label}</label>
            <textarea data-testid={`prop-${k}`} rows="2" value={f[k]} onChange={(e) => set(k, e.target.value)} />
          </div>
        ))}
      </div>
      <button data-testid="prop-save" onClick={save} disabled={busy} className="btn-primary mt-4">{busy ? "Saving…" : "Save Property Information"}</button>
    </div>
  );
}
